export default "__VITE_ASSET__e4228941__"